import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "react-query";
import { renderRoutes } from "react-router-config";
import { HashRouter as Router } from "react-router-dom";
import { GoogleAPIProvider } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";
import { Toaster } from "@jti/ui";
import ReferralRunner from "./components/ReferralRunner";
import { LinkBehaviourContextProvider } from "./contexts/LinkBehaviourContextProvider";
import ScrollToTop from "./utils/ScrollToTop";
import { routes } from "./routes";
const queryClient = new QueryClient();
const App = () => {
    return (_jsx(GoogleAPIProvider, { apiKey: getConfig().GOOGLE_PLACES_KEY, options: { libraries: ["places"] }, children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(Toaster, {}), _jsx(ReferralRunner, {}), _jsx(LinkBehaviourContextProvider, { children: _jsxs(Router, { children: [_jsx(ScrollToTop, {}), renderRoutes(routes)] }) })] }) }));
};
export default App;
